<template>
  <v-dialog v-model="isDialogEnabled" max-width="500px" persistent>
    <v-card class="elevation-1">
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-container fluid>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="formModel.Name"
                  :counter="50"
                  :rules="getRules.Name"
                  name="Name"
                  label="Name"
                  id="Name"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <v-select
                  v-model="formModel.CenterId"
                  :items="centers"
                  item-text="name"
                  name="CenterName"
                  label="Center Name"
                  id="CenterName"
                  required
                  item-value="Id"
                ></v-select>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-select
                  v-model="formModel.ServiceId"
                  :items="services"
                  name="ServiceOffered"
                  label="Service Offered"
                  id="ServiceOffered"
                  required
                ></v-select>
              </v-flex>

              <v-flex xs12 sm6>
                <v-menu
                  v-model="dobPickerStart"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="formModel.StartDate"
                      name="StateDate"
                      id="StateDate"
                      label="State Date"
                      hint="YYYY-MM-DD format"
                      persistent-hint
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="formModel.StartDate"
                    @input="dobPickerStart = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm6>
                <v-menu
                  v-model="dobPickerEnd"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="formModel.EndDate"
                      name="EndDate"
                      id="EndDate"
                      label="End Date"
                      hint="YYYY-MM-DD format"
                      persistent-hint
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="formModel.EndDate"
                    @input="dobPickerEnd = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click="cancel">Cancel</v-btn>
        <v-btn color="primary darken-1" @click="save" :disabled="!valid"
          >Save</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import dbStore from "../db/dbStore";
import Rules from "../rules";
import { mapMutations, mapGetters } from "vuex";

export default {
  name: "BatchForm",
  data: function() {
    return {
      valid: true,
      models: {},
      formModel: {},
      dobPickerStart: false,
      dobPickerEnd: false,
      isDialogEnabled: false,
      service: null,
      services: [],
      centers: [],
      centerId: null
    };
  },
  props: {
    formContext: {
      type: String,
      required: true
    },
    model: {
      type: Object,
      required: true
    },
    isFormEnabled: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    getRules() {
      var rulesObject = Rules.getComponentRules("Batch");
      //console.log(rulesObject)
      return rulesObject;
    },
    formTitle() {
      var title = "";
      if (this.formContext == "add") {
        title = "New Batch";
      } else if (this.formContext == "edit") {
        //#TODO write logic for editing a batch info
        title = "Edit Batch";
      }
      return title;
    },
    login_details: function() {
      return this.$store.getters.get_login_details;
    }
  },

  watch: {
    isFormEnabled() {
      //console.log("entered")
      //on add student case, in edit we dont need, this is useful to track
      //back button on top right and reset form if user clicks back and comes
      //here again, then form is reset
      if (this.isFormEnabled) {
        if (this.formContext == "add") {
          this.formModel = Object.assign({}, this.models["emptyModel"]);
        }
        this.$refs.form.resetValidation();
        this.isDialogEnabled = true;
      }
    }
  },

  created() {
    //when created
    // in approval store model with students info so that when we come back we can reset other fields
    if (this.formContext == "add") {
      this.models["emptyModel"] = Object.assign({}, this.model);
    }
    //this.isDialogEnabled = true
    this.getData();
  },
  mounted() {
    // when we click send for approval in students page and come back then show empty model
    // as if we are adding new approval
    if (this.formContext == "add") {
      this.formModel = Object.assign({}, this.models["emptyModel"]);
    }
    this.$refs.form.resetValidation();
  },

  methods: {
    async getData() {
      dbStore.setCollectionName("centers");
      this.centers = await dbStore.getItems();
      this.centers = await this.filterCenters()
      dbStore.setCollectionName("services");
      this.services = await dbStore.getItems();
      this.services = this.services[0]["1"];
    },
    
    async filterCenters() {
      var temp = []
      var centerId = this.login_details.centerId
      this.centers.forEach(center => {
        if(center.id === centerId) {
          temp.push(center)
        }
      });
      return temp
    },
    async addBatch() {
      let response;
      try {
        //console.log(this.formModel)
        dbStore.setCollectionName("batches");
        response = await dbStore.addItem(this.formModel);
        if (response.isStateChanged) {
          this.$refs.form.resetValidation();
          this.isDialogEnabled = false;
          this.$emit("batchFormAddEvent", true);
        }
      } catch (err) {
        //throw.error(err);
        console.log("Error adding batch : " + err);
      }
    },

    cancel() {
      this.$refs.form.resetValidation();
      this.isDialogEnabled = false;
      this.$emit("batchFormCancelEvent", true);
    },

    save() {
      if (this.$refs.form.validate()) {
        if (this.formContext == "add") {
          //console.log(this.formModel)
          //#TODO change static data to dynamic data
          this.formModel.Center = 1;
          this.formModel.ServicesOffered = ["NDLM"];

          this.addBatch();
        }
      }
    },

    ...mapMutations([
      "_login_details"
    ])
  }
};
</script>
